module.exports = __webpack_public_path__ + "238a96f89bf46618d57ade5b5ee43b89.jpg";